<template>
  <div id="ReasonList">
    <div :class="`loader${loaderClass}`" v-show="loading">
    </div>
    <div id="page-content-wrapper" class="admin-content-area"
         :style="listOnly ? 'padding-top: 0 !important;padding-bottom: 0 !important' : ''">
      <template v-if="cantAccessPage === true">
        <div class="page-name" v-if="!listOnly">
          <div class="page-title"> Damage Code List</div>
          <router-link v-if="canAddReason" class="btn btn-primary pull-right" v-bind:to="{name: 'ReasonCreate'}"><i
            class="fp-add"> </i> Add
          </router-link>
        </div>
        <div class="container-fluid" :class="listOnly ? 'no-height-limit' : ''">
          <div class="admin-page-content reason-list">
            <data-table-filter-config :moduleName="'reasonList'" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'" ref="filterReasonList"></data-table-filter-config>
            <section class="data-table bg-white">
              <custom-pagination
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange" :moduleName="'reasonList'" :position="'top'">
              </custom-pagination>

              <vue-good-table
                :class="listOnly ? 'table-list-only-height' : ''"
                ref="listReasonTable"
                mode="remote"
                title="Reason"
                @on-page-change="onPageChange"
                @on-selected-rows-change="selectionChanged"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange"
                @on-sort-change="onSortChange"
                :totalRows="totalRecords"
                :columns="userColumns"
                :rows="rows"
                :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                :select-options="{
                                    enabled: term_value && !listOnly,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                :search-options="{
                                    enabled: false,
                                    }">

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                  <div :key="key">
                    <div v-if="props.column.field == 'action'">
                      <template v-if="canUpdateReason">
                        <router-link title="Edit Reason" class="fp-edit"
                                     v-bind:to="{name: 'ReasonEdit',params:{id:props.row.id}}"></router-link>
                      </template>
                    </div>
                    <div v-else>
                      {{ props.formattedRow[props.column.field] }}
                    </div>
                  </div>
                </template>

                <div slot="selected-row-actions">
                  <button v-if="term_value" id="deleteReasonBtn" v-on:click.prevent="reasonDelete"
                          class="btn btn-danger">Delete
                  </button>
                </div>
              </vue-good-table>
              <custom-pagination
                v-if="!listOnly"
                :page-changed="onPageChange"
                :per-page-changed="onPerPageChange">
              </custom-pagination>
            </section>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer v-if="!listOnly"></app-footer>
    </div>
  </div>
</template>
<script>
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

export default {
  name: "ReasonList",
  metaInfo() {
    return {title: "Damage Code List | " + process.env.COPYRIGHT_NAME}
  },
  mixins: [commonMixins, dataTableMixins],
  props: {
    listOnly: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    firstLoad: 0,
    permissions: [],
    cantAccessPage: "",
    userColumns: [],
    columns: [
      {
        label: 'Actions',
        field: 'action',
        hidden: true,
        sortable: false,
      },
      {
        label: 'Code',
        field: 'code',
        filterable: true,
        hidden: false,
        fpFieldType: "text",
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Code", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: 'Name',
        field: 'name',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Name", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
    ],
    rows: [],
    totalRecords: 0,
    term_value: false,
    loading: false,
    canUpdateReason: false,
    canAddReason: false,
  }),
  watch: {

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {
        for (var i = 0; i < permissions.length; i++) {
          if (permissions[i].name === 'list_damage_code') {
            self.cantAccessPage = true;
          }
          if (permissions[i].name === 'delete_damage_code') {
            self.term_value = true;
          }
          if (permissions[i].name === 'add_damage_code') {
            self.canAddReason = true;
            self.canUpdateReason = true;
          }
        }
        if (!this.listOnly && this.canAddReason) {
          this.$nextTick(() => {
            this.columns[0].hidden = false;
          });
        }
      }

    }

  },
  created: function () {

  },
  mounted: function () {
    var self = this;

    //self.loadList();
    self.getPermissions();
    if (!self.listOnly) {
      document.title = "Damage Code | " + process.env.COPYRIGHT_NAME;
    }
  },
  methods: {
    cancelAll: function () {
      this.$refs.listReasonTable.unselectAllInternal();
    },

    selectionChanged(param) {
      if (param.selectedRows.length === 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
    },

    loadList() {
      var self = this;
      self.loading = true;
      var fields = {
        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
      };
      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/reason/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          if (data.status === "success") {
            self.rows = data.content.row;
            self.totalRecords = data.content.totalRecords;
            self.filteredFlag = false;
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, false, 'reason-list')
        }
      });
    },

    reasonDelete() {
      var self = this;
      self.$swal({
        title: 'Are you sure that you want to delete this Damage Code?',
        type: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCloseButton: false,
        showLoaderOnConfirm: true
      }).then((result) => {
        if (result.value) {
          var data = this.$refs['listReasonTable'].selectedRows;
          var use = [];
          for (var i = 0; i < data.length; i++) {
            use.push(this.$refs['listReasonTable'].selectedRows[i].id)
          }
          self.loading = true;
          $("#deleteReasonBtn").val("Deleting ...");
          $.ajax({
            url: process.env.ROOT_API + "/reason/delete",
            type: "POST",
            data: 'id=' + use,
            headers: this.ajxHeaders,
            dataType: 'json',
            success: function (data) {
              self.loading = false;
              setTimeout(function () {
                $(".alert-success").removeClass("show");
                $(".alert-success").addClass("hide");
              }, 10000);
              setTimeout(function () {
                $("#deleteReasonBtn").val("Delete");
              }, 10000);

              var currentlyMapped = data.content.currentlyMappedArr;
              self.notDeletedSwal(currentlyMapped);
              self.loadList();
            },
            error: function (jqXHR, exception) {
              self.loading = false;
              self.generateStatusCodeMessage(jqXHR, true, 'reason-delete')
            }
          });

        } else {
          console.log("no");
        }
      });
    },
    notDeletedSwal(currentlyMapped) {
      if (currentlyMapped.length > 0) {
        currentlyMapped = currentlyMapped.toString();
        this.$swal({
          title: 'The following damage code/s could not be deleted, as they are currently in use!',
          text: currentlyMapped,
          type: 'warning',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: 'Close',
        });
      }
    }
  }
};
</script>
<style scoped>
.table-list-only-height {
  height: 50vh;
  overflow: auto;
}

.no-height-limit {
  min-height: auto !important;
}
</style>




// WEBPACK FOOTER //
// src/components/ReasonList.vue